import SwiperCore from 'swiper/core';

const relatedArticles = () => {
    // eslint-disable-next-line no-unused-vars
    const swiper = new SwiperCore('.swiper-container-related', {
        slidesPerView: 1.4,
        spaceBetween: 20,
        preventClicks: false,
        preventClicksPropagation: false,
        slideToClickedSlide: false,
        breakpoints: {
            600: {
                slidesPerView: 2.4,
            },
            869: {
                slidesPerView: 3.4,
            },
            1024: {
                slidesPerView: 4.4,
            },
        },
    });
};

export default relatedArticles;
